/* Native-layout integration uses the real vendor form and controls; no custom send API.
 * Original Liquid labels/layout/options remain authoritative. Vendor controls,
 * error nodes, CAPTCHA, submit button and submission handler remain intact.
 */
(() => {
  if (window.DRNativeRetailForms) return;
  const ROOT = '[data-native-retail-app]';
  const MAPS = {
    'retail-product': { text: 'contact[name]', email: 'contact[email]', 'text-1': 'contact[phone]', textarea: 'contact[body]', select: 'contact[How did you hear about us]' },
    'retail-custom': { text: 'contact[name]', 'text-1': 'contact[phone]', email: 'contact[email]', country: 'contact[country]', select: 'contact[shape]', textarea: 'contact[body]', 'select-1': 'contact[How did you hear about us]' },
    'retail-international': { text: 'contact[First Name]', 'text-2': 'contact[Last Name]', email: 'contact[email]', 'text-1': 'contact[Phone or Mobile]', country: 'contact[Country]', 'text-3': 'contact[City]', textarea: 'contact[body]', select: 'contact[How did you hear about us]' }
  };
  const HIDDEN = {
    'retail-product': { hidden: 'retail_product', 'hidden-1': 'retail_selection', 'hidden-2': 'retail_enquiry_type' },
    'retail-custom': { hidden: 'retail_product', 'hidden-1': 'retail_selection', 'hidden-2': 'retail_enquiry_type', 'hidden-3': 'retail_rep_email' },
    'retail-international': { hidden: 'retail_enquiry_type', 'hidden-1': 'retail_count', 'hidden-2': 'retail_detected_country', 'hidden-3': 'retail_currency', 'hidden-4': 'retail_list' }
  };
  function named(root, name) {
    return [...root.querySelectorAll('input,select,textarea')].find(control => control.name === name);
  }
  function write(control, value) {
    if (!control || control.value === String(value ?? '')) return;
    control.value = String(value ?? '');
    control.dispatchEvent(new Event('input', { bubbles: true }));
    control.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function sync(wrapper) {
    if (!wrapper?.matches?.(ROOT)) return;
    const source = wrapper.querySelector('[data-native-context]');
    if (!source || !source.querySelector('[data-enquiry-type-field]')) return;
    const value = name => named(source, name)?.value || '';
    const data = {
      retail_product: value('contact[product]'), retail_selection: value('contact[Selected size and construction]'),
      retail_enquiry_type: value('contact[enquiry_type]') || value('contact[Request Type]'),
      retail_count: value('contact[Pieces enquired about]'), retail_currency: value('contact[Currency shown]'),
      retail_detected_country: value('contact[Detected country]'),
      retail_rep_email: source.querySelector('[data-native-rep-email]')?.value || '',
      retail_list: [...source.querySelectorAll('input')].filter(input => /^contact\[Piece \d+\]$/.test(input.name))
        .map(input => input.name.slice(8, -1) + ': ' + input.value).join('\n')
    };
    wrapper.dataset.enquiryType = data.retail_enquiry_type;
    const ctx = wrapper.__drAppFormContext || { hidden: {}, prefill: {} };
    Object.assign(ctx.hidden, data);
    wrapper.__drAppFormContext = ctx;
    window.Globo = window.Globo || {};
    window.Globo.FormBuilder = window.Globo.FormBuilder || {};
    window.Globo.FormBuilder.dr = window.Globo.FormBuilder.dr || {};
    Object.assign(window.Globo.FormBuilder.dr, data);
    const form = wrapper.querySelector('form');
    if (!form) return;
    Object.entries(HIDDEN[wrapper.dataset.nativeRetailApp]).forEach(([id, key]) => write(named(form, id), data[key]));
  }
  function decorate(wrapper) {
    const form = wrapper.querySelector('form[action*="powerfulform.com/api/front/form/"]');
    if (!form || form.dataset.nativeLayoutReady) return;
    const fields = MAPS[wrapper.dataset.nativeRetailApp];
    const template = wrapper.querySelector('template[data-native-layout]');
    const content = form.querySelector('.content.block-container');
    const footer = form.querySelector('.footer');
    const submit = footer?.querySelector('button.submit');
    if (!fields || !template || !content || !submit) return;
    const fragment = template.content.cloneNode(true);
    // Keep newly configured postcode fields in the merchant's field order.
    // Previously only MAPS fields moved into the styled layout, leaving new
    // fields above it with the app's default filled-input styling.
    const configuredBoxes = [...form.querySelectorAll('[data-element-id]')];
    const postcodeBoxes = configuredBoxes.filter(box => {
      const label = box.querySelector('label.globo-label');
      const text = (label?.dataset.label || label?.textContent || '').replace(/\*/g, '').trim();
      return !fields[box.dataset.elementId] && /^(post\s*code|postal\s*code|zip\s*code)(\s*\/.*)?$/i.test(text)
        && box.querySelector('input[type="text"]');
    });
    const pairs = Object.entries(fields).map(([id, name]) => {
      const native = named(fragment, name);
      const box = [...form.querySelectorAll('[data-element-id]')].find(element => element.dataset.elementId === id);
      const control = box && named(box, id);
      return { id, native, box, control };
    });
    // Atomic contract check: no half-rearranged, partly working form.
    if (pairs.some(pair => !pair.native || !pair.box || !pair.control || pair.native.tagName !== pair.control.tagName)) return;
    const buttonTemplate = fragment.querySelector('button[type="submit"]');
    if (!buttonTemplate) return;
    const context = wrapper.querySelector('[data-native-context]');
    fragment.querySelectorAll('input[type="hidden"]').forEach(input => context.append(input));
    const pendingType = wrapper.dataset.nativePendingEnquiryType;
    const typeInput = context.querySelector('[data-enquiry-type-field]');
    if (pendingType && typeInput) {
      typeInput.dataset.defaultType = typeInput.value;
      typeInput.value = pendingType;
    }
    const layout = document.createElement('div');
    layout.dataset.nativeLayoutRendered = 'true';
    layout.append(fragment);
    pairs.forEach(({ native, box, control }) => {
      const originalId = native.id;
      // Keep all vendor IDs/names/presence validation/aria-describedby and live
      // listeners; copy native visual/accessibility/input-behaviour attributes.
      [...native.attributes].forEach(attribute => {
        if (['id', 'name', 'value', 'class'].includes(attribute.name)) return;
        control.setAttribute(attribute.name, attribute.value);
      });
      control.classList.add(...native.classList);
      control.required = native.required || control.hasAttribute('presence');
      if (control.tagName === 'SELECT') control.replaceChildren(...[...native.options].map(option => option.cloneNode(true)));
      write(control, native.value);
      layout.querySelectorAll('label').forEach(label => {
        if (label.htmlFor !== originalId) return;
        label.htmlFor = control.id;
        if (control.required && !label.textContent.includes('*')) label.append(' *');
      });
      box.dataset.nativeFieldShell = 'true';
      native.replaceWith(box);
    });
    postcodeBoxes.forEach(box => {
      const control = named(box, box.dataset.elementId);
      const next = configuredBoxes.slice(configuredBoxes.indexOf(box) + 1)
        .find(candidate => pairs.some(pair => pair.box === candidate));
      const nextControl = next && named(next, next.dataset.elementId);
      let anchor = nextControl && [...layout.querySelectorAll('label')]
        .find(label => label.htmlFor === nextControl.id);
      anchor = anchor || buttonTemplate;
      while (anchor.parentElement && anchor.parentElement !== layout) anchor = anchor.parentElement;
      const label = document.createElement('label');
      label.htmlFor = control.id;
      label.textContent = 'Postcode *';
      control.required = true;
      control.autocomplete = 'postal-code';
      control.placeholder = '';
      // Text, not number: preserve leading zeros and international postcodes.
      box.dataset.nativeFieldShell = 'true';
      if (wrapper.dataset.nativeRetailApp === 'retail-international') {
        const field = document.createElement('div');
        field.className = 'form-field';
        label.className = 'form-label';
        control.classList.add('form-input');
        field.append(label, box);
        anchor.before(field);
      } else {
        label.className = 'side-sheet__label';
        control.classList.add('side-sheet__input');
        anchor.before(label, box);
      }
    });
    submit.classList.add(...buttonTemplate.classList);
    submit.type = 'submit';
    // Retain the app spinner and update only label text nodes.
    [...submit.childNodes].filter(node => node.nodeType === Node.TEXT_NODE).forEach(node => node.remove());
    submit.append(document.createTextNode(buttonTemplate.textContent));
    footer.dataset.nativeFooter = 'true';
    buttonTemplate.replaceWith(footer);
    content.append(layout);
    // Vendor may assign/use its form ID during send/reset. Preserve it. The
    // stable former native DOM anchor belongs to the placement wrapper now.
    wrapper.id = wrapper.dataset.nativeFormId;
    form.classList.add(...wrapper.dataset.nativeFormClass.split(/\s+/).filter(Boolean));
    // Native HTML required/email validity remains an additional guard; vendor
    // validation, CAPTCHA, response handling and send engine are not replaced.
    form.addEventListener('submit', event => {
      sync(wrapper);
      if (!form.reportValidity()) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    form.dataset.nativeLayoutReady = 'true';
    wrapper.dataset.nativeLayoutReady = 'true';
    wrapper.querySelector('[data-native-app-status]').hidden = true;
    const country = wrapper.querySelector('[data-intl-country-select]');
    const detected = document.documentElement.dataset.enquiryCountry;
    const cc = document.documentElement.dataset.enquiryMode;
    if (country && detected && cc) {
      const option = [...country.options].find(option => option.value === cc || option.textContent.trim() === detected);
      if (option) write(country, option.value);
      const hidden = context.querySelector('[data-intl-country-hidden]');
      if (hidden) hidden.value = detected;
    }
    const product = wrapper.closest('product-page');
    if (typeof product?.updateSheetContext === 'function') product.updateSheetContext();
    sync(wrapper);
  }
  function scan() { document.querySelectorAll(ROOT).forEach(decorate); }
  let queued = false;
  function queue() { if (!queued) { queued = true; requestAnimationFrame(() => { queued = false; scan(); }); } }
  ['focusin', 'pointerdown', 'submit'].forEach(name => document.addEventListener(name, event => {
    const wrapper = event.target.closest?.(ROOT);
    if (!wrapper) return;
    sync(wrapper);
    if (name === 'submit' && !wrapper.dataset.nativeLayoutReady) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true));
  window.DRNativeRetailForms = { sync, scan };
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', queue);
  document.addEventListener('globo.formbuilder.form.loaded', queue);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
})();
